var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91699 13.834C8.31445 13.834 9.62402 13.4121 10.7139 12.6914L14.5635 16.5498C14.8184 16.7959 15.1436 16.9189 15.4951 16.9189C16.2246 16.9189 16.7607 16.3477 16.7607 15.627C16.7607 15.293 16.6465 14.9678 16.4004 14.7217L12.5771 10.8809C13.3682 9.75586 13.834 8.39355 13.834 6.91699C13.834 3.11133 10.7227 0 6.91699 0C3.12012 0 0 3.11133 0 6.91699C0 10.7227 3.11133 13.834 6.91699 13.834ZM6.91699 11.9883C4.13086 11.9883 1.8457 9.70312 1.8457 6.91699C1.8457 4.13086 4.13086 1.8457 6.91699 1.8457C9.70312 1.8457 11.9883 4.13086 11.9883 6.91699C11.9883 9.70312 9.70312 11.9883 6.91699 11.9883Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingglass);
export default __webpack_public_path__ + "static/media/magnifyingglass.31406abec2df36385443d6c38947f84e.svg";
export { ForwardRef as ReactComponent };